var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"ListItems"},[_c('a',{attrs:{"href":"item.uri"}},[_vm._v("\n            "+_vm._s(item.title)+"\n        ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }